

export const isNumber = (input) => {
    const numberRegex = /^[0-9]*$/
    return (numberRegex.test(input))
}
export const isCorrectPostalCodeRegex = (input) => {
    const postalCodeRegex = /\b(?!(\d)\1{3})[13-9]{4}[1346-9][0123-9]{5}\b/
    return (postalCodeRegex.test(input))
}

export const isCorrectPhone = (input) => {
    const phoneRegex = /^0[0-9]{2}[0-9]{8}$/
    return (phoneRegex.test(input))
}

export const isCorrectEmail= (input) => {
    const emailRegex =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return (emailRegex.test(input))
}




